var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBooking2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.37C7.34794 2.37 7.63 2.65206 7.63 3V4H8H16H16.37V3C16.37 2.65206 16.6521 2.37 17 2.37C17.3479 2.37 17.63 2.65206 17.63 3V4H18H19C19.5304 4 20.0391 4.21071 20.4142 4.58579C20.7893 4.96086 21 5.46957 21 6V20C21 21.11 20.11 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V6C3 4.9 3.9 4 5 4H6H6.37V3C6.37 2.65206 6.65206 2.37 7 2.37ZM4.5 20.5V8.5H19.5V20.5H4.5ZM10.88 13H8.50651C8.11849 13 7.95773 13.497 8.27223 13.7242L10.19 15.11L9.45642 17.39C9.3378 17.7587 9.76004 18.0639 10.0729 17.8357L12 16.43L13.9212 17.8314C14.2346 18.0601 14.6574 17.7533 14.5372 17.3844L13.8 15.12L15.7232 13.7237C16.0368 13.496 15.8758 13 15.4882 13H13.12L12.3803 10.7282C12.2605 10.36 11.7395 10.36 11.6197 10.7282L10.88 13Z",
    fill: "#555555"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBooking2);
export default __webpack_public_path__ + "static/media/ic_booking2.2f744b44e112682340588b7ccce506ed.svg";
export { ForwardRef as ReactComponent };